import { useMemo } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

function CalibrationHistoryTable({ selectedDevice, calibrationHistoryData }) {
  const tableData = useMemo(() => {
    const columns = [
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Time",
        accessor: "time",
      },
      {
        Header: "MILK",
        accessor: "milk",
      },
      {
        Header: "LOW FAT MILK",
        disableSortBy: true,
        align: "center",
        borderLeft: true,
        borderRight: true,
        columns: [
          {
            Header: "FAT",
            accessor: "lowFatMilk.fat",
            borderLeft: true,
          },
          {
            Header: "SNF",
            accessor: "lowFatMilk.snf",
          },
          {
            Header: "DEN",
            accessor: "lowFatMilk.den",
          },
          {
            Header: "PRO",
            accessor: "lowFatMilk.pro",
          },
          {
            Header: "LAC",
            accessor: "lowFatMilk.lac",
          },
          {
            Header: "SOL",
            accessor: "lowFatMilk.sol",
            borderRight: true,
          },
        ],
      },
      {
        Header: "HIGH FAT MILK",
        disableSortBy: true,
        align: "center",
        borderLeft: true,
        borderRight: true,
        columns: [
          {
            Header: "FAT",
            accessor: "highFatMilk.fat",
            borderLeft: true,
          },
          {
            Header: "SNF",
            accessor: "highFatMilk.snf",
          },
          {
            Header: "DEN",
            accessor: "highFatMilk.den",
          },
          {
            Header: "PRO",
            accessor: "highFatMilk.pro",
          },
          {
            Header: "LAC",
            accessor: "highFatMilk.lac",
          },
          {
            Header: "SOL",
            accessor: "highFatMilk.sol",
            borderRight: true,
          },
        ],
      },
    ];

    const rows =
      calibrationHistoryData?.map((record) => {
        return {
          date: record.Date,
          time: record.Time,
          milk: record.Milk || "N/A",
          lowFatMilk: {
            fat: record.LowFat_Fat || "N/A",
            snf: record.LowFat_SNF || "N/A",
            den: record.LowFat_Den || "N/A",
            pro: record.LowFat_Pro || "N/A",
            lac: record.LowFat_Lac || "N/A",
            sol: record.LowFat_Sol || "N/A",
          },
          highFatMilk: {
            fat: record.HighFat_Fat || "N/A",
            snf: record.HighFat_SNF || "N/A",
            den: record.HighFat_Den || "N/A",
            pro: record.HighFat_Pro || "N/A",
            lac: record.HighFat_Lac || "N/A",
            sol: record.HighFat_Sol || "N/A",
          },
        };
      }) || [];

    return { columns, rows };
  }, [calibrationHistoryData, selectedDevice]);

  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Calibration History for Device {selectedDevice}
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={tableData}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
}

CalibrationHistoryTable.propTypes = {
  selectedDevice: PropTypes.string.isRequired,
  calibrationHistoryData: PropTypes.arrayOf(PropTypes.object),
};

export default CalibrationHistoryTable;
